import React, { useState } from 'react';
import { useTenant } from '../contexts/TenantContext';
import { Link } from 'react-router-dom';
import './TenantStatusBar.css';

/**
 * Barra di stato per visualizzare informazioni sul tenant attivo
 * e fornire accesso rapido alle funzionalità di gestione
 */
const TenantStatusBar: React.FC = () => {
    const { tenantId, tenantInfo, loading, error } = useTenant();
    const [expanded, setExpanded] = useState(false);

    // Se non c'è un tenant selezionato, non mostrare la barra
    if (!tenantId && !loading) return null;

    return (
        <div className={`tenant-status-bar ${expanded ? 'expanded' : ''}`}>
            <div className="tenant-status-bar__main" onClick={() => setExpanded(!expanded)}>
                <div className="tenant-status-bar__info">
                    {loading ? (
                        <span className="tenant-status-bar__loading">Caricamento...</span>
                    ) : error ? (
                        <span className="tenant-status-bar__error">Errore: {error}</span>
                    ) : (
                        <>
                            <span className="tenant-status-bar__name">
                                {tenantInfo?.logoUrl && (
                                    <img src={tenantInfo.logoUrl} alt={tenantInfo.nome} style={{ height: 26, verticalAlign: 'middle', marginRight: 6, borderRadius: 4, background: '#fff', padding: 2 }} />
                                )}
                                {tenantInfo?.nome || `Tenant ${tenantId}`}
                            </span>
                            <span className="tenant-status-bar__id">ID: {tenantId}</span>
                        </>
                    )}
                </div>
                <button
                    className="tenant-status-bar__toggle"
                    aria-label={expanded ? 'Riduci' : 'Espandi'}
                >
                    {expanded ? '▲' : '▼'}
                </button>
            </div>

            {expanded && (
                <div className="tenant-status-bar__expanded">
                    <div className="tenant-status-bar__details">
                        {tenantInfo?.indirizzo && (
                            <div className="tenant-status-bar__detail">
                                <span className="tenant-status-bar__label">Indirizzo:</span>
                                <span>{tenantInfo.indirizzo}</span>
                            </div>
                        )}
                        {tenantInfo?.telefono && (
                            <div className="tenant-status-bar__detail">
                                <span className="tenant-status-bar__label">Telefono:</span>
                                <span>{tenantInfo.telefono}</span>
                            </div>
                        )}
                        {tenantInfo?.orariApertura && (
                            <div className="tenant-status-bar__detail">
                                <span className="tenant-status-bar__label">Orari:</span>
                                <span>{tenantInfo.orariApertura}</span>
                            </div>
                        )}
                    </div>

                    <div className="tenant-status-bar__actions">
                        <Link to={`/menu?tenantId=${tenantId}`} className="tenant-status-bar__action">
                            Visualizza Menu
                        </Link>
                        <Link to="/admin/tenants" className="tenant-status-bar__action tenant-status-bar__action--admin">
                            Gestione Tenant
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TenantStatusBar;
